let hostname = window.location.hostname, base_url, base_api, base_pdf;

if(hostname==="localhost") {        
    base_url="http://localhost:3000"
    base_api="http://localhost/contracts.ph/api"
    base_pdf="http://localhost/contracts.ph/pdfs"     
} else if(hostname==="dev.contracts.ph") {
    base_url="https://dev.contracts.ph"
    base_api="https://api.contracts.ph/api"
    base_pdf="https://api.contracts.ph/pdfs" 
} else {
    base_url="https://contracts.ph"
    base_api="https://api.contracts.ph/api"
    base_pdf="https://api.contracts.ph/pdfs"
}

const Env = {
    BASE_URL: base_url,
    BASE_API: base_api,
    BASE_PDF: base_pdf,
    SUPPORT_EMAIL: "support@contracts.ph",
    SITE_NAME: "Contracts.ph"
}

export default Env


// WEBPACK FOOTER //
// ./src/model/Env.js